// extracted by mini-css-extract-plugin
export default {"container":"ExportComponent_container__ttGRN","exportButton":"ExportComponent_exportButton__QkSNT","text":"ExportComponent_text__rXg8R"};